window.theme = theme || {};

theme.customerTemplates = (function() {
  var selectors = {
    RecoverEmail: '#RecoverEmail',
    LoginEmail: '#CustomerEmail'
  };

  function initEventListeners() {
    this.$RecoverEmail = $(selectors.RecoverEmail);
    this.$LoginEmail = $(selectors.LoginEmail);

    $(selectors.LoginEmail).focus();

    // Show reset password form
    $('#RecoverPassword').on('click',function(evt) {
      evt.preventDefault();
      showRecoverPasswordForm();
    }.bind(this));

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click',function(evt) {
      evt.preventDefault();
      hideRecoverPasswordForm();
      this.$LoginEmail.attr('tabindex', '-1').focus();
    }.bind(this));

    this.$RecoverEmail.on('blur', function() {
      $(this).removeAttr('tabindex');
    });

    this.$LoginEmail.on('blur', function() {
      $(this).removeAttr('tabindex');
    });

    // Set logged in status to false, used for GA loginEvent
    if($('form.ga-track-login').length){
      localStorage.setItem('hs-ga-logged-in','false');
    }
  }

  /* Show/Hide recover password form */
  function showRecoverPasswordForm() {
    $('#RecoverPasswordForm').removeClass('hide');
    $('#CustomerLoginForm').addClass('hide');
    this.$RecoverEmail.focus();
  }

  function hideRecoverPasswordForm() {
    $('#RecoverPasswordForm').addClass('hide');
    $('#CustomerLoginForm').removeClass('hide');
  }

  /* Show reset password success message */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide').focus();
  }

  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  /* Show/hide customer address forms */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      new Shopify.CountryProvinceSelector('AddressCountryNew','AddressProvinceNew',{hideElement: 'AddressProvinceContainerNew'});
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle edit address forms
    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      var $editButton = $('#EditFormButton_' + formId);
      var $editAddress = $('#EditAddress_' + formId);
      var isExpanded = $editButton.attr('aria-expanded') === 'true';

      $('.address-edit-form').not('#EditAddress_' + formId).addClass('hide');
      $editAddress.toggleClass('hide');
      if($editAddress.hasClass('hide')) {
        $newAddressForm.removeClass('hide');
      } else {
        $newAddressForm.addClass('hide');
      }
      $editButton.attr('aria-expanded', !isExpanded).focus();
    });

    var currentUrl = window.location.href;
    if(currentUrl.indexOf('/account/addresses?edit') !== -1){
      var editID = getParameterByName('edit',currentUrl);
      $('#AddressNewForm').addClass('hide');
      $('#EditAddress_'+editID).removeClass('hide');
      var navHeight = 0;
      enquire.register(theme.breakpoints.mediaQueryMediumUp, {
        match: function() {
          navHeight = $('.site-header__nav-bar').outerHeight();
        }
      });
      var animateTo = $('#EditAddress_'+editID).offset().top - navHeight - 35;
      $('html,body').animate({scrollTop: animateTo}, 500);
    }

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var target = $el.data('target');
      var confirmMessage = $el.data('confirm-message');

      if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        Shopify.postLink(target, {
          parameters: { _method: 'delete' }
        });
      }
    });
  }

  /* Check URL for reset password hash */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      showRecoverPasswordForm.bind(this)();
    }
  }

  return {
    init: function() {
      initEventListeners();
      checkUrlHash();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();

$(document).ready(function(){
  theme.customerTemplates.init();
});